import { useState } from 'react';
import { ChipAction, Menu } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { getStatusTranslations } from 'app/domains/tasks/utils/taskStatus';
import { TaskStatusEnumEnum } from 'shared/domains/apollo/generated/types';
import { ChipDropdown } from 'shared/domains/common-ui';
import { formatLabel } from './utils/formatLabel';
export function StatusFilter(props) {
    const { clear, onChange, value = [], label, tab } = props;
    const statusValues = Object.values(TaskStatusEnumEnum);
    const statuses = getStatusTranslations();
    const [open, setOpen] = useState(false);
    const closeDropdown = () => setOpen(false);
    const toggleDropdown = () => setOpen(!open);
    const handleChange = (options) => {
        const { status, checked } = options;
        if (checked) {
            onChange([...value, status]);
        }
        else {
            const filteredStatuses = value.filter((s) => s !== status);
            onChange(filteredStatuses);
        }
    };
    if (tab === 'completed') {
        return null;
    }
    return (<ChipDropdown open={open} onClose={closeDropdown} onClick={toggleDropdown} label={formatLabel(label, value)} action={value.length > 0 && (<ChipAction onClick={clear}>
            <Falcon icon="remove"/>
          </ChipAction>)}>
      {statusValues.map((status) => (<Menu.ItemCheckbox key={status} checked={value.includes(status)} onChange={(checked) => handleChange({ checked, status })}>
          {statuses[status].label}
        </Menu.ItemCheckbox>))}
    </ChipDropdown>);
}
